/* eslint-disable max-lines-per-function */
import { FieldBase } from '@/components/form';
import { Toggle } from '@e2n/ui';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function StundenpensumToggle() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-neutrals-900 text-xl font-bold leading-7">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.description',
        )}
      </h2>
      <form.AppField
        name="bezahlung.sollstunden.stundenpensum"
        listeners={{
          onChange({ value }) {
            if (value === 'woche') {
              form.resetField('bezahlung.sollstunden.berechnungsartMonat');
              form.resetField('bezahlung.sollstunden.monatsstunden');
              form.resetField(
                'bezahlung.sollstunden.unbezahlteUeberstundenMonat',
              );
            } else if (value === 'monat') {
              form.resetField('bezahlung.sollstunden.wochenstunden');
              form.resetField(
                'bezahlung.sollstunden.unbezahlteUeberstundenWoche',
              );
            }
          },
        }}>
        {(field) => (
          <FieldBase>
            <div className="flex items-start gap-4">
              <Toggle
                pressed={field.state.value === 'monat'}
                onPressedChange={() => field.handleChange('monat')}
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                {t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.options.monat',
                )}
              </Toggle>
              <Toggle
                pressed={field.state.value === 'woche'}
                onPressedChange={() => field.handleChange('woche')}
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                {t(
                  'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.stundenpensum.options.woche',
                )}
              </Toggle>
            </div>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
